export default __webpack_public_path__ + "static/media/img9.2bbc81f0.jpg";